<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.subject_treemaps', 2),
                        href: meta.links.index,
                    },
                    {
                        name: subjectTreemap.title,
                        href: null,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.title')" for="title" />
                            <FormInput
                                required
                                id="title"
                                v-model="form.title"
                                name="title"
                                type="text"
                                max="191"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.title" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.active')" for="is_active" />
                            <input
                                id="is_active"
                                type="checkbox"
                                v-model="form.is_active"
                                name="is_active"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                            <FormError :value="form.errors.is_active" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.published_at')" for="published_at" />
                            <FormInput
                                required
                                id="published_at"
                                v-model="form.published_at"
                                name="published_at"
                                type="datetime-local"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.published_at" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.unpublished_at')" for="unpublished_at" />
                            <FormInput
                                required
                                id="unpublished_at"
                                v-model="form.unpublished_at"
                                name="unpublished_at"
                                type="datetime-local"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.unpublished_at" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="mt-5">
                <TreemapTagWeightForm :blocks="options.blocks" v-model="form.tags" />
            </div>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import TreemapTagWeightForm from './partials/TreemapTagWeightForm.vue';
import SubmitFormButton from '../Subactivities/SubmitFormButton.vue';
import SmartBreadcrumbs from '../../../../components/SmartBreadcrumbs.vue';

export default {
    components: {
        SmartBreadcrumbs,
        SubmitFormButton,
        TreemapTagWeightForm,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'options', 'filters', 'subjectTreemap'],
    data() {
        return {
            form: this.$inertia.form({
                is_active: this.subjectTreemap.is_active,
                title: this.subjectTreemap.title,
                published_at: this.subjectTreemap.published_at,
                unpublished_at: this.subjectTreemap.unpublished_at,
                tags: [],
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
